import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {FlatListState} from './FlatListState';
import {HttpStatusCode, LogType} from '../../swagger';
import {formatDateTime} from '../../helpers/helpers';
import {UptimeEventsListComponent} from './UptimeEventsListComponent';

export interface FlatListUptimeInfoProps {
    state: FlatListState;
}

export const UptimeInfoComponent: FunctionComponent<FlatListUptimeInfoProps> = observer(({state}) => {
        if (!state.log! || !state.log.uptimeCheckDocument || (state.log?.uptimeCheckDocument?.lastStatusCode as unknown) === 0) {
            return <div/>;
        }

        const u = state.log?.uptimeCheckDocument;
        const ok = u.lastStatusCode == HttpStatusCode.Ok;
        const errorCount = (u?.errorCount ?? 0);
        const total = (u?.errorCount ?? 0) + (u?.successCount ?? 1);
        const percent = Math.round((100 - ((errorCount / total / 100) * 100)) * 1000) / 1000;
        const logTypeUptimeCheck = state.log.logType === LogType.UptimeCheck;

        const statusCode = u?.lastStatusCode == HttpStatusCode.Gone ? 'Connection Timeout' : u?.lastStatusCode;
        return <React.Fragment>
            <div
                data-tut="uptimestatus"
                className="mb-4 mt-2">
                <div className="w-full" title={ok ? 'Last time unavailable: ' + (u?.lastErrorTime ? formatDateTime(u?.lastErrorTime) : 'never') : ''}>
                    <span className={`h-2 w-2 inline-block rounded-full mr-2 ${ok ? 'Trace' : 'Error blink30s'}`}/>
                    <span className={ok ? 'text-m-green' : 'text-m-brand-red'}>{ok ? 'Service status: OK (Up ' + percent + '%)' : 'Service not available'}</span>
                    {ok === false && <span className={'ml-2 text-xs text-m-gray-6 '}>HTTP STATUS: {statusCode}</span>}
                    {(!logTypeUptimeCheck && (u?.errorCount ?? 0 > 0)) && <button
                        className="text-m-gray-6 text-xs ml-2"
                        onClick={() => state.setShowUptimeEventsList(!state.showUptimeEventsList)}>
                        {state.showUptimeEventsList ? 'hide details' : 'more info'}
                    </button>}
                </div>
                {/*{(u?.lastErrorResponse && u.lastErrorResponse.length > 0 && u?.lastStatusCode != HttpStatusCode.Gone) &&
                <div className="bg-m-gray-2 text-m-gray-6  p-2 overflow-auto h-24 break-all text-xs">
                    {u?.lastErrorResponse}
                </div>}*/}
                {(state.log && state.log.logId && (logTypeUptimeCheck || state.showUptimeEventsList)) &&
                    <UptimeEventsListComponent logId={state.log.logId} limit={logTypeUptimeCheck ? 30 : 10}/>}
            </div>
        </React.Fragment>;
    },
);
